import { brandInfo, socialLinks } from '@/mocks/homeData';

export default function TopBar() {
  return (
    <div className="w-full bg-primary-900 text-background-100">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-2 py-2 text-xs">
          <div className="flex items-center gap-1.5">
            {socialLinks.map((item) => (
              <a
                key={item.id}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={item.label}
                title={item.label}
                className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-800/70 text-background-100 hover:bg-accent-500 hover:text-primary-950 transition-colors cursor-pointer"
              >
                <i className={`${item.icon} text-sm`}></i>
              </a>
            ))}
          </div>

          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-1 text-background-100/90">
            <span className="hidden sm:flex items-center gap-2">
              <i className="ri-map-pin-2-line text-accent-300"></i>
              Madurai, Tamil Nadu
            </span>
            <a
              href={`mailto:${brandInfo.email}`}
              className="hidden lg:flex items-center gap-2 hover:text-accent-300 transition-colors cursor-pointer"
            >
              <i className="ri-mail-line text-accent-300"></i>
              {brandInfo.email}
            </a>
            <a
              href={`tel:${brandInfo.phonePrimary.replace(/\s/g, '')}`}
              className="flex items-center gap-2 font-semibold hover:text-accent-300 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill text-accent-300"></i>
              {brandInfo.phonePrimary}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}